/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `oldest` - Oldest created
 * * `direct_match_first` - Direct match preferred
 * * `highest_flux` - Highest flux
 * @export
 */
export const MainStrategyEnum = {
    Oldest: 'oldest',
    DirectMatchFirst: 'direct_match_first',
    HighestFlux: 'highest_flux'
} as const;
export type MainStrategyEnum = typeof MainStrategyEnum[keyof typeof MainStrategyEnum];


export function instanceOfMainStrategyEnum(value: any): boolean {
    for (const key in MainStrategyEnum) {
        if (Object.prototype.hasOwnProperty.call(MainStrategyEnum, key)) {
            if (MainStrategyEnum[key as keyof typeof MainStrategyEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MainStrategyEnumFromJSON(json: any): MainStrategyEnum {
    return MainStrategyEnumFromJSONTyped(json, false);
}

export function MainStrategyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainStrategyEnum {
    return json as MainStrategyEnum;
}

export function MainStrategyEnumToJSON(value?: MainStrategyEnum | null): any {
    return value as any;
}

export function MainStrategyEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): MainStrategyEnum {
    return value as MainStrategyEnum;
}

